$(document).ready(() => {
  if (!$('html').hasClass('template-blog') && !$('html').hasClass('template-article')) return;

  $('.article-instagram-tab-item').click(function() {
    const $this = $(this);
    const target = $this.data('target');
  
    $('.article-instagram-tab-item').removeClass('active');
    $this.addClass('active');
    
    showInstagramTabContent(target);
  });

  $('[data-article-instagram-select]').change(function(e) {
    const { value } = e.target;
  
    showInstagramTabContent(value);
  });

  function showInstagramTabContent(target) {
    $('.article-instagram-images-content').removeClass('active');
    $(`.article-instagram-images-content[data-content-for="${target}"]`).addClass('active');
  }
});
